import AppTable from "../componens/appTable";
export default function Dashboard({ canManage = false, canCreate = false }) {
  return <AppTable canManage={canManage} canCreate={canCreate} />;
}
